<template>
  <v-container v-if="true" id="vacationContainer" style="width: 100%">
      <div style="width: 100%" class="text-center avatarPos mb-2 mt-n3">
           <span  v-bind:class="[getColorStatus().color]" style="font-size: 14px; margin-left: -20px">{{getTextStatus().textStatus}}</span>
           <div style="width: 70px; float: left" class="ml-n12 mt-1">
               <v-avatar @click="back" style="position: fixed" width="18px" height="18px">
             <img s src="@/assets/back.png" />
           </v-avatar>
           </div>
         </div>
       <v-layout column>
        <v-flex id="flexHeader" d-flex>
            <header-vacation :VacationData="{VacationData: VacationData.VacationData, userInfomation: VacationData.userInfomation}" id="headerVacation"></header-vacation>
        </v-flex>
        <v-flex class="mt-7" id="flexInformation" d-flex>
            <div style="width: 100%;">
       <v-col style="height: 100%;">
          <v-row>
             <h4 style="font-size: 14px">{{ $t("vacation_detail_approve_information") }}</h4>
             <v-divider class="divider"></v-divider>
          </v-row>
          <v-row class="mt-4">
             <v-textarea
                  id="textArea"
                  flat
                  no-resize
                  rows="06"
                  background-color="#F4F4F4"
                  v-model="reasonManager"
                  maxlength="150"
                ></v-textarea>
          </v-row>
          <v-row>
            <div v-show="showAnimation" id="approveAnimation" style="text-align: center; background-color: #3FE090; color: white; height: 30px; width: 100%; font-size: 14px; padding-top: 4px; z-index: 3">{{ $t("vacation_detail_reject_approve_success") }}</div>
           <div style="background-color: yellow; width: 100%; margin-top: 35px"><v-btn v-on:click="rejectVacation" style="color: white" id="btnReject" >{{ $t("vacation_detail_reject") }}</v-btn></div>
          </v-row>
        </v-col>  
    </div>
        </v-flex>
      </v-layout>
  </v-container>
</template>


<script>
    import moment from 'moment';
    import HeaderVacation from '../../components/commonui/vacations/HeaderVacation'
    import { ListEvents, VacationStatus } from "@/utilities/CommonUtilities";
    import { mapState } from "vuex";
    export default {
        name :'VacationApprove',
        components: {HeaderVacation},
        props:{
          VacationData: Object
        },
        computed: {
         ...mapState(["userInfo"]),
         ...mapState(["listUser", "token", "listReason"]),
        },
        data () {
            return {
                inprogressVacation: 'inprogressVacation',
                approvedVacation: 'approvedVacation',
                rejectedVacation: 'rejectedVacation',
                canceledVacation: 'canceledVacation',
                inprogressText: this.$i18n.t("vacations_inprogress"),
                approvedText: this.$i18n.t("vacations_approved"),
                rejectedText: this.$i18n.t("vacations_rejected"),
                canceledText: this.$i18n.t("vacations_past"),
                reasonManager: '',
                showAnimation: false,
                callRejectApi: true,
            }
        },
        methods:{
            getColorStatus(){
             let color = "";
             if(this.VacationData.VacationData.status == VacationStatus.InProgress){
               color =  this.inprogressVacation;
              }
             else if(this.VacationData.VacationData.status == VacationStatus.Approved){
               color =  this.approvedVacation;
              }
             else if(this.VacationData.VacationData.status == VacationStatus.Rejected){
               color =  this.rejectedVacation;
              }
              else {
               color =  this.canceledVacation;
              }
              return {color: color};
           },
           getTextStatus(){
             let textStatus = "";
              if(this.VacationData.VacationData.status == VacationStatus.InProgress){
                 textStatus = this.inprogressText;
              }
              else if(this.VacationData.VacationData.status == VacationStatus.Approved){
                 textStatus =  this.approvedText;
              }
              else if(this.VacationData.VacationData.status == VacationStatus.Rejected){
                 textStatus =  this.rejectedText;
              }
              else{
                textStatus = this.canceledText;
              }
              return {textStatus: textStatus};
           },
           back() {
             this.$emit('backtoDetailScreen', this.VacationData.VacationDetail)
           },
           async rejectVacation() {
             if(this.callRejectApi){
               try{
                   this.callRejectApi = false;
                   this.notifyBus.$emit(ListEvents.showLoadingIndicator);
                   let dictParams = {
                    'id': this.VacationData.VacationData.id,
                    'apply_uid': this.userInfo.userID,
                    'token': this.token,
                    'status': VacationStatus.Rejected,
                    'reason_manager': this.reasonManager
                   };
                   await this.dataSource.postData(
                   this.dataSource.approveVacationURL, dictParams);
                   this.VacationData.VacationDetail[0].status = VacationStatus.Rejected;
                   this.VacationData.VacationDetail[0].apply_uid = this.userInfo.userID;
                   this.VacationData.VacationDetail[0].apply_date = moment().format("YYYY-MM-DD HH:mm:ss");
                   this.VacationData.VacationDetail[0].reason_manager = this.reasonManager;
                   this.notifyBus.$emit(ListEvents.hideLoadingIndicator);
                   this.showAnimation = true;
                   setTimeout(() => this.$emit('backtoDetailScreen', this.VacationData.VacationDetail), 3000);
                   this.notifyBus.$emit(ListEvents.reloadAllTabs);
               } catch(ex) {
                   this.callRejectApi = true;
                   this.notifyBus.$emit(ListEvents.hideLoadingIndicator);
                   this.notifyBus.$emit(ListEvents.showOKDialog, this.$i18n.t('common_unknown_error'));
               }
             }
          },
        },
        inject: ["dataSource", "notifyBus"],
    }
</script>
<style scoped>
    #headerVacation{
      height: 100%;
      width: 100%;
    }
    #flexButton {
      position: -webkit-sticky;
      position: sticky;
      bottom: 0;
      font-size: 20px;
    }
    #headerVacation{
      background-color: white;
    }    
    #flexHeader{
      height: 200px;
    }
    #flexInformation{
      height: 350px;
    }
    #flexButton{
      height: 20px;
    }
    #flexAnimation{
      height: 100px;
      margin-bottom: 0px;
    }
    button{
      width: 100%;
      color: white;
      height: 35px;
      font-size: 16px;
      font-weight: bold;
      border-radius: 2px;
    }
    #btnReject{
      background-color: #E561A9;
      z-index: 2;
  }
    #approveAnimation{
     position: relative;
     animation-name: example;
     animation-duration: 3s;  
     animation-fill-mode: forwards;
    }
    @keyframes example {
    from {top: 200px;}
    to {top: 0px; background-color: #3FE090;}
   }
    .inprogressVacation{
      color: #F1BD42;
    }
    .approvedVacation{
      color: #3FE090
    }
    .rejectedVacation{
      color: red
    }
    .canceledVacation{
      color: grey
    }
    .divider {
      margin-top: 10px;
      margin-right: 10px;
      margin-left: 10px;
    }
    textarea:focus {outline:0;}
    .v-textarea--no-resize >>> textarea {
      padding: 10px !important;
      }
</style>
